import styled from 'styled-components';
import { darken } from 'polished';
//
import colors from 'theme/colors';

const { darkPanelBackground, lightBackgroundBase, lightBackgroundElevation2 } = colors;

const colorMultiplier = 0.1;

export default styled.button`
  background-color: ${darkPanelBackground};
  border: 1px solid ${lightBackgroundElevation2};
  color: ${lightBackgroundBase};
  transition: 0.2s background-color ease-in;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  border-radius: 3px;
  font-size: 14px;
  font-weight: 500;
  padding: 0px 16px;

  &:hover {
    background-color: ${darken(colorMultiplier, darkPanelBackground)};
    cursor: pointer;
  }

  &:focus {
    outline: none;
  }
`;
